import { render, staticRenderFns } from "./Jstudent.vue?vue&type=template&id=b8480222"
import script from "./Jstudent.vue?vue&type=script&lang=js"
export * from "./Jstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports